var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import { Button } from './link';
import { TertiaryStyles } from '../Button/tertiary';
var TertiaryButton = styled(Button)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), TertiaryStyles);
export default TertiaryButton;
var templateObject_1;
//# sourceMappingURL=tertiaryButton.js.map